import {
  ContentType,
  DomainTag,
  SearchType,
  SectorTag,
  StakeTag,
  StartupApi,
  SubDomainTag,
  Tag,
  TagApi,
} from 'pleinchamp-api-client';
import { ApiConfiguration, axiosInstance } from '@api/business/api.conf';

export const StartupApiService = new StartupApi(ApiConfiguration, undefined, axiosInstance);
export const TagApiService = new TagApi(ApiConfiguration, undefined, axiosInstance);

export const NB_STARTUP_PER_PAGE = 10;

export function getEnumFromTagRemoteId(list: Tag[]): (StakeTag | DomainTag | SectorTag | SubDomainTag)[] {
  return list.map(item => item.remoteId);
}

export function fetchStartups(
  q?: string,
  stakes?: Tag[],
  domains?: Tag[],
  sectors?: Tag[],
  isHostedByCa?: boolean,
  offset = 0,
  limit = NB_STARTUP_PER_PAGE,
  options?: any
) {
  const stakesEnum = stakes ? (getEnumFromTagRemoteId(stakes) as StakeTag[]) : [];
  const domainsEnum = domains ? (getEnumFromTagRemoteId(domains) as DomainTag[]) : [];
  const sectorsEnum = sectors ? (getEnumFromTagRemoteId(sectors) as SectorTag[]) : [];
  return StartupApiService.search(
    q,
    [ContentType.Startup],
    SearchType.Partial,
    stakesEnum,
    domainsEnum,
    sectorsEnum,
    isHostedByCa === true ? isHostedByCa : undefined,
    offset,
    limit,
    options
  ).then(data => data.data);
}

export function fetchTagByRemoteId(remoteId: string, depth?: number, options?: any) {
  return TagApiService.getTagByRemoteId(remoteId, depth, options).then(data => data.data);
}

export function fetchChildrenTagByRemoteId(remoteId: string, depth?: number, options?: any) {
  return TagApiService.getChildrenTagByRemoteId(remoteId, depth, options).then(data => data.data);
}

export function fetchStartup(slug: string, options?: any) {
  return StartupApiService.getStartup(slug, options).then(r => r.data);
}

export function fetchRelatedStartups(slug: string, options?: any) {
  return StartupApiService.getRelatedStartup(slug, options).then(r => r.data);
}

export function fetchContactImageDefault(options?: any) {
  return StartupApiService.getContactImageDefaut(options).then(data => data.data);
}
